import React from 'react'
import { useMLForm } from '../../../../common/provider/form/Form.provider'
import { SimpleInput } from '../../../../common/components/simpleInput'
import classes from '../formadd.module.scss'
import { Button } from 'antd'
import { IoTrashOutline } from 'react-icons/io5'

const FieldEmail = () => {
  const { Form } = useMLForm()
  const { List, } = Form
  return (
    <List name="customerEmails" >

      {(fields, action) => (
        <div className='my-3 border p-3 rounded'>
           <h6>Email(s)</h6>
          {
            fields.map((field, index) => (
              <div className={`${classes['d-grid']} ${classes['grid-2-50px']} align-items-end  mb-2`} key={field.key}>
                <div className='w-100' >
                  <SimpleInput
                    Form={Form}
                    name={[field.name, 'email']}
                    label={'Email'}
                    placeholder={'Email'}
                  />
                </div>
               <Button className={`${index==0 ? 'd-none ':''}`} onClick={() => action.remove(index)} type="primary" shape="circle" icon={<IoTrashOutline />} color="red" variant="solid" size={"large"} />
              </div>
            ))
          }
          <div>
            <Button type="dashed" size={'large'} onClick={() => action.add({
              email:''
            })}>
              Ajouter
            </Button>
          </div>
        </div>
      )}
    </List>
  )
}

export default FieldEmail